import * as React from 'react';

const SvgCloseCircleFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm3.09-14.477 1.41 1.42-3.084 3.06 3.075 3.085-1.417 1.412-3.078-3.088-3.086 3.065-1.41-1.42 3.084-3.06L7.509 8.91 8.926 7.5l3.078 3.088 3.086-3.065Z", fill: "currentColor" })));

export { SvgCloseCircleFill as default };
